<template>
  <svg
    preserveAspectRatio="xMidYMid meet"
    data-bbox="0 0 544.476 80"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="`0 0 544.477 80`"
    :height="height"
    :width="width"
    data-type="color"
    role="presentation"
    aria-hidden="true"
    aria-label=""
  >
    <g>
      <path
        d="M46.208 33.006v13.989H14.782V78.25H0V33.006zM49.712.001V13.99L0 13.989 13.993 0z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M94.277 71.257h-.876q-2.519 4.044-6.788 6.393T76.867 80q-10.183 0-15.165-6.23-4.983-6.229-4.982-16.611V24.7h14.344v30.71q0 5.792 2.573 8.58 2.574 2.786 7.5 2.786 2.957 0 5.202-1.257a12.1 12.1 0 0 0 3.832-3.388q1.588-2.13 2.41-5.027.82-2.895.82-6.175V24.7h14.345v53.551H94.277z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M126.47 36.94h-9.417V24.7h9.417V8.307h14.344V24.7h13.14v12.24h-13.14v20.765q0 1.858.383 3.443t1.478 2.677q1.533 1.749 4.38 1.749 1.862 0 2.957-.383a9.3 9.3 0 0 0 2.08-1.038l4.051 12.568a23.7 23.7 0 0 1-5.42 1.804q-2.902.6-6.405.6-4.051 0-7.282-1.256t-5.42-3.443q-5.146-4.917-5.146-13.989z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M201.585 71.257h-.876q-2.52 4.044-6.789 6.393T184.175 80q-10.184 0-15.166-6.23-4.982-6.229-4.982-16.611V24.7h14.344v30.71q0 5.792 2.574 8.58 2.572 2.786 7.5 2.786 2.957 0 5.201-1.257a12.1 12.1 0 0 0 3.833-3.388q1.587-2.13 2.409-5.027.82-2.895.82-6.175V24.7h14.345v53.551h-13.468z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M227.317 24.7h13.468v7.432h.876a13.8 13.8 0 0 1 2.628-3.607 18.6 18.6 0 0 1 3.668-2.841q2.025-1.203 4.38-1.858 2.354-.656 4.653-.656 2.848 0 4.873.547 2.025.546 3.45 1.42l-3.833 13.006a13.6 13.6 0 0 0-2.902-1.039q-1.587-.382-3.887-.382-2.956 0-5.365 1.147a11.8 11.8 0 0 0-4.107 3.224q-1.697 2.077-2.627 4.864t-.931 6.065v26.23h-14.344z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M319.404 65.355q-3.723 6.558-10.019 10.601T294.001 80q-6.132 0-11.333-2.131t-9.034-5.956-5.968-9.017q-2.135-5.19-2.135-11.42 0-5.793 2.08-10.984 2.082-5.19 5.804-9.07t8.815-6.175q5.091-2.295 11.223-2.295 6.461 0 11.497 2.13 5.037 2.132 8.432 5.902 3.394 3.771 5.146 8.907t1.752 11.148v1.311q-.11.656-.11 1.202a6 6 0 0 0-.109 1.202h-40.405q.438 3.279 1.807 5.629t3.395 3.934a13.2 13.2 0 0 0 4.434 2.295q2.41.71 4.928.71 4.927 0 8.157-2.24t5.092-5.628zm-13.03-20.764q-.11-1.421-.93-3.17-.822-1.748-2.41-3.278-1.587-1.53-3.942-2.514-2.354-.984-5.639-.984-4.599 0-8.103 2.623t-4.927 7.323z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M347.974 9.614v27.53h15.928q6.027 0 10.224-3.987 4.198-3.987 4.198-9.887 0-5.462-3.928-9.56-3.93-4.096-9.848-4.096zm0 68.608h-9.9V0h26.259q10.008 0 17.058 6.719t7.05 16.551q0 8.084-5.22 14.366t-13.184 8.03l-.215.328 21.631 31.791v.437h-11.73L358.952 46.54h-10.978z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M422.592 80q-12.01 0-19.795-8.065t-7.785-20.38q0-12.205 7.562-20.325 7.563-8.118 19.35-8.119 12.122 0 19.295 7.683 7.173 7.684 7.173 21.524l-.11 1.09h-42.816q.222 7.847 5.338 12.642t12.233 4.795q9.786 0 15.347-9.59l9.119 4.36q-3.67 6.757-10.176 10.57Q430.821 80 422.592 80m-16.348-34.874h31.25q-.445-5.558-4.615-9.21-4.17-3.65-11.177-3.65-5.783 0-9.953 3.487t-5.505 9.373"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M457.289 24.854h9.741v7.406h.443q2.325-3.92 7.14-6.535 4.815-2.614 10.018-2.614 9.963 0 15.331 5.61 5.37 5.608 5.37 15.955v33.546h-10.185V45.33q-.332-13.07-13.394-13.07-6.089 0-10.184 4.847-4.095 4.845-4.096 11.6v29.515H457.29z"
        :fill="color"
        data-color="1"
      ></path>
      <path
        d="M535.316 80q-6.544 0-10.851-4.06t-4.417-11.304V34.568h-9.379V25.35h9.379V8.889h10.033v16.46h13.087v9.219H530.08v26.776q0 5.378 2.072 7.298t4.69 1.92q1.2 0 2.344-.274 1.146-.274 2.127-.713l3.163 8.998Q540.55 80 535.316 80"
        :fill="color"
        data-color="1"
      ></path>
    </g>
  </svg>
</template>
<script setup>
import { defineProps } from "vue";
const props = defineProps({
  color: {
    type: String,
    default: "#FFFFFF",
  },
  width: {
    type: String,
    default: "544.477",
  },
  height: {
    type: String,
    default: "50",
  },
});
const color = props.color ?? "#FFFFFF";
const width = props.width ?? "544.477";
const height = props.height ?? "50";
</script>
